import FirstRunApp from '@forwardflow/features/first-run/FirstRunApp'

/**
 * `/start`, `/start/home`, `/start/campaign`, `/start/:page`: the first run
 * as UI only (light mode, demo data, no backend). See `features/first-run`.
 */
export default function StartPage({ view }: { view: 'wizard' | 'home' | 'campaign' | 'page' }) {
   return <FirstRunApp view={view === 'wizard' ? 'setup' : view} />
}
